<template>
  <div id="modalWriteReceiptQuantity" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-16 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("distributor.手工确认入库数量") }}
            <span v-if="items && items.length > 0" class="tx-gary-300 tx-14"
              >({{ $t("distributor.共有") }}{{ items.length
              }}{{ $t("distributor.个快递包裹") }})</span
            >
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-t-5 pd-b-0 model-auto-h">
          <div class="c-n-wrap">
            <div class="card bd-0 bg-white">
              <div class="card-header">
                <h4>{{ $t("distributor.包裹列表") }}</h4>
                <ul class="select-express">
                  <li v-for="(item, index) in items" :key="index">
                    <div :class="{ active: tabs[index] }">
                      <label class="rdiobox">
                        <input
                          name="express"
                          type="radio"
                          :checked="tabs[index]"
                          @change="changeActive(index)"
                        />
                        <span
                          >{{ $t("distributor.包裹") }}{{ index + 1 + ": "
                          }}<strong class="tx-primary mg-r-5">{{
                            item.expressCode
                          }}</strong>
                          ({{ item.productInfo.length
                          }}{{ $t("rm.种sku") }})</span
                        >
                        <i
                          v-show="item.isReceived == 1"
                          class="fa fa-check tx-success tx-12"
                          aria-hidden="true"
                        ></i>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="card-body"
                v-for="(item, index) in items"
                :key="index"
                v-show="tabs[index]"
              >
                <h4 class="body-title d-flex justify-content-between">
                  <span
                    >{{ $t("distributor.包裹") }}{{ index + 1
                    }}{{ $t("distributor.商品清单") }}</span
                  >
                  <span
                    >({{ $t("distributor.包裹状态:") }}
                    <span v-if="item.isReceived == 1" class="tx-success">{{
                      $t("distributor.已入库")
                    }}</span
                    ><span v-else>{{ $t("distributor.未入库") }}</span
                    >)</span
                  >
                </h4>
                <div class="form-wrap">
                  <table class="table table-striped mg-b-0">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th width="60"></th>
                        <th class="tx-center">
                          {{ $t("distributor.发货数量") }}
                        </th>
                        <th width="90">{{ $t("distributor.入库数量") }}</th>
                        <th>{{ $t("distributor.备注") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="product in item.productInfo"
                        :key="product.sku"
                      >
                        <td class="align-middle">
                          {{ product.sku }}
                        </td>
                        <td>
                          <div
                            class="img-wrap"
                            v-lazy:background-image="product.imgUrl"
                          ></div>
                        </td>
                        <td class="tx-center align-middle">
                          {{ product.deliveryCnt }}
                        </td>
                        <td class="tx-center align-middle">
                          <input
                            v-if="item.isReceived != 1"
                            class="form-control form-control-sm"
                            style="width: 80px"
                            type="number"
                            v-INT
                            v-model="product.receivedQuantity"
                          />
                          <span v-else>{{ product.receivedQuantity }}</span>
                        </td>
                        <td class="align-middle">
                          <input
                            v-if="item.isReceived != 1"
                            class="form-control form-control-sm"
                            style="width: 100%"
                            type="text"
                            v-model="product.remark"
                          />
                          <span v-else>{{ product.remark }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="item.isReceived != 1" class="action tx-center">
                  <button
                    type="button"
                    class="
                      btn btn-primary
                      tx-12 tx-uppercase
                      pd-y-12 pd-x-25
                      tx-mont tx-semibold
                    "
                    @click="save(index)"
                  >
                    {{ $t("distributor.确认提交") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("distributor.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["code", "items"],
  data() {
    return {
      tabs: [],
    };
  },
  watch: {
    items() {
      this.tabs = [];
      (this.items || []).forEach(() => {
        this.tabs.push(false);
      });
      this.$set(this.tabs, 0, true);
    },
  },
  methods: {
    changeActive(i) {
      //tab切换
      this.tabs.forEach((e, n) => {
        this.$set(this.tabs, n, i == n);
      });
    },
    save(i) {
      let error = false;
      this.items[i].productInfo.forEach((e) => {
        if (e.deliveryCnt != e.receivedQuantity && !e.remark) {
          error = true;
        }
      });
      if (error) {
        ShowTip(
          this.$t("distributor.发货数量和入库数不同，请填写备注"),
          "danger"
        );
        return;
      }
      let productInfo = [];
      this.items[i].productInfo.forEach((e) => {
        productInfo.push({
          num: e.receivedQuantity,
          supplierProductStockId: e.supplierProductStockId,
          remark: e.remark,
        });
      });
      let params = {
        code: this.code,
        warehouseData: {
          expressCode: this.items[i].expressCode,
          productInfo,
        },
      };
      this.$parent.loading = true;
      $.api_call("api.SupplierPurchaseOrder.warehouse", params, (r) => {
        this.$parent.loading = false;
        if (r.ErrorCode == "9999") {
          this.items[i].isReceived = 1;
          ShowTip(this.$t("distributor.入库数量已保存"), "success");
          setTimeout(() => {
            this.$parent.getRMOrder(true);
            this.$parent.getRMStatusNum();
          }, 2000);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>


<style scoped>
.card-body {
  padding-top: 0.5rem;
}
.card-header {
  padding-bottom: 0;
}
.card-header-tabs {
  border-bottom: 1px #dee2e6 solid;
}
.card-header-tabs .nav-link.active {
  background-color: #fff;
  color: #17a2b8;
  border: 1px #dee2e6 solid;
  border-bottom-color: #fff;
}
.nav .nav-link {
  color: #666;
}
.nav .nav-link:hover,
.nav .nav-link:active {
  font-weight: bold;
}
.card-header {
  background-color: transparent;
}
.form-wrap {
  margin-bottom: 1rem;
  padding-right: 1rem;
  max-height: 285px;
  overflow-y: auto;
}
.modal-header h6 span {
  color: #666;
}
.select-express {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.select-express li {
  flex: 1;
  min-width: 50%;
  max-width: 50%;
  overflow: hidden;
  padding: 5px 10px;
}
.select-express label {
  margin: 0;
  font-size: 12px;
}
.select-express li > div {
  padding: 5px;
  border-radius: 4px;
}
.select-express li > div.active {
  background-color: #e6e6e6;
}
.select-express li > div.active span {
  font-weight: bold;
}
.card-header h4 {
  margin: 0;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px #ccc solid;
}
.body-title {
  padding: 0;
  margin: 0;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  font-weight: bold;
}
.img-wrap {
  width: 50px;
  height: 50px;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px #ccc solid;
  background-color: #fff;
}
</style>